// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2ojcJ","validationTips":"StatementDescriptor_validationTips__LR95W"};